"use strict";

import React from 'react';
import {validate as validateEmail} from "email-validator";

const AccountEmailFormInput = ({register=()=>{}, errors={}, isValidating=false,
                               legend='Email',
                               emailIsUnique=()=>{},formInputClassName=()=>{},}) => {
    return (
        <fieldset className="account___form__fieldset">
            {!!legend &&
                <legend>{legend}</legend>
            }
            <ol className="form__input-list account__form__list is-marginless">
                <li className="form__input-list-item is-marginless">
                    <label htmlFor="account-form--email"
                           className="label__required">
                        Email
                    </label>
                    <input type="email"
                           {...register('email', {
                               required: true,
                               maxLength: 50,
                               validate: {
                                   validateEmail: (value)=>{
                                       return validateEmail(value) || 'invalid email address';
                                   },
                                   isUnique: async (value) => await emailIsUnique(value).then((response)=>{
                                       return true;
                                   }).catch((error)=>{return false;}),
                               },
                           })}
                           id="account-form--email"
                           className={formInputClassName('email')} />
                    {!!errors.email && errors.email.type === 'validateEmail' &&
                    <small className="form__error">A valid email address is required</small>
                    }
                    {!!errors.email && errors.email.type === 'isUnique' && !isValidating &&
                    <small className="form__error">This email is already in use</small>
                    }
                </li>
            </ol>
        </fieldset>
    );
};

export default AccountEmailFormInput;
